import PropTypes from 'prop-types';
import { useState } from 'react';

// material
import { Box, Modal, Typography, Stack, IconButton, Button, Divider } from '@mui/material';

import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import Iconify from '../../../components/iconify';

// ------------------------------------------------------------------------------------------------

ConfirmationPopup.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    setOpen: PropTypes.func.isRequired,  // more general name
    onConfirm: PropTypes.func.isRequired, // more general name
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
};
// ------------------------------------------------------------------------------------------------

export default function ConfirmationPopup(props) {
    const { children, title, msg, onConfirm, setOpen } = props;
    const [isLoading, setIsLoading] = useState(false);

    const handleCancel = () => {
        setOpen(false);
    };

    const handleYes = () => {
        setIsLoading(true);
        onConfirm(true);
        setOpen(false);
    };

    const buttonStyle = {
        alignItems: 'center',
        borderRadius: "10px",
        height: '2em',
        padding: '0.3em',
        color: 'white'
    };

    return (
        <div>
            <Modal
                open
                BackdropProps={{
                    style: { backgroundColor: 'transparent' }
                }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 'inset 0 0 0 #b3b3b3, 0 1px 0 0 #b3b3b3, 0 1.5px 1px #999999 !important',
                    borderRadius: 1.5,
                    width: 300,
                }}>
                    <Stack
                        direction='row'
                        alignItems="center"
                        justifyContent='space-between'
                        sx={{
                            bgcolor: '#f27c88',
                            height: 42,
                            width: '100%',
                            borderTopLeftRadius: '10px',
                            borderTopRightRadius: '10px',
                        }}
                    >
                        <Typography variant='subtitle1' sx={{ color: '#fff', p: 2 }}>
                            {title}
                        </Typography>

                        <IconButton onClick={handleCancel} sx={{ p: 0, color: '#fff' }}>
                            <Iconify icon="jam:close" width='24px' height='24px' />
                        </IconButton>
                    </Stack>

                    <Stack direction='row' alignItems="center" justifyContent='space-between' sx={{ p: 1 }}>
                        <Typography variant='body2'>
                            {msg}
                        </Typography>
                    </Stack>
                    <Divider sx={{ mt: 2 }} />
                    <Box sx={{ m: 1.7, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant='contained' sx={{
                            marginRight: 1, bgcolor: '#43b5a2', minWidth: '2.4em',
                            minHeight: '1.5em', color: '#fff', '&:hover': {
                                bgcolor: '#43b5a2',
                            },
                        }} onClick={handleCancel} style={buttonStyle}>No</Button>
                        <Button variant='contained' sx={{
                            bgcolor: '#ED5565', color: '#fff', minWidth: '1.5em',
                            minHeight: '1.5em', '&:hover': {
                                bgcolor: '#ED5565',
                            },
                        }} onClick={handleYes} style={buttonStyle}>Yes</Button>
                    </Box>
                    <Box>
                        {children}
                    </Box>
                    {isLoading && (
                        <Box sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            bgcolor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: 1.5,
                        }}>
                            <LoadingProgressBar />
                        </Box>
                    )}
                </Box>
            </Modal>
        </div>
    );
}
